// ----------------------------------------------------------------------
export function tooltip(theme) {
    const lightMode = theme.palette.mode === "light";
    return {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: theme.palette.grey[lightMode ? 800 : 700],
                    maxHeight: "60vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                    scrollbarWidth: "thin",
                    scrollbarColor: `${theme.palette.grey[500]} transparent`,
                    "&::-webkit-scrollbar": {
                        width: 6,
                    },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: theme.palette.grey[500],
                        borderRadius: 3,
                    },
                    "&::-webkit-scrollbar-track": {
                        backgroundColor: "transparent",
                    },
                },
                arrow: {
                    color: theme.palette.grey[lightMode ? 800 : 700],
                },
            },
        },
    };
}
